const PACK_TYPE_DYNAMIC_VALUE = 'dynamic';
const PACK_TYPE_FIXED_VALUE = 'fixed';
const PACK_TYPE_OPTIONS = [
  { label: 'Fijo', value: PACK_TYPE_FIXED_VALUE },
  { label: 'Dinámico', value: PACK_TYPE_DYNAMIC_VALUE },
];

export { PACK_TYPE_DYNAMIC_VALUE, PACK_TYPE_FIXED_VALUE, PACK_TYPE_OPTIONS };
